import React from 'react'
import classNames from 'classnames'

import cogs from '../../images/about-us/Cogs_v1.svg'
import teamwork from '../../images/about-us/Teamwork.svg'
import grow from '../../images/about-us/Grow.svg'

class TabsAboutUs extends React.Component {
  state = {
    tab: 'tabA',
  }

  render() {
    const { tab } = this.state
    const classA = classNames({ 'is-active': tab === 'tabA' })
    const classB = classNames({ 'is-active': tab === 'tabB' })
    const classC = classNames({ 'is-active': tab === 'tabC' })

    return (
      <section className="section">
        <div className="container content">
          <div className="columns is-centered">
            <div className="column is-three-quarters-desktop">
              <div className="section-title">
                <h2 className="title">
                  Living Up To Your Team's Full Potential
                </h2>
                <p className="subtitle">
                  We believe in building better products and more engaged
                  teams.
                </p>
              </div>
              <div className="tabs image-tabs is-large is-centered">
                <ul>
                  <li className={classA}>
                    <button id="tabA" onClick={this.toggleTab}>
                      <div>
                        <img className="icon" src={cogs} alt="" />
                        <p>Iterate</p>
                        <p>Quickly</p>
                      </div>
                    </button>
                  </li>
                  <li className={classB}>
                    <button id="tabB" onClick={this.toggleTab}>
                      <div>
                        <img className="icon" src={teamwork} alt="" />
                        <p>Collaborate</p>
                        <p>Better</p>
                      </div>
                    </button>
                  </li>
                  <li className={classC}>
                    <button id="tabC" onClick={this.toggleTab}>
                      <div>
                        <img className="icon" src={grow} alt="" />
                        <p>Learn</p>
                        <p>&amp; Grow</p>
                      </div>
                    </button>
                  </li>
                </ul>
              </div>

              {tab === 'tabA' && (
                <div className="tabContent tabContent--selected">
                  <p className="text-bold is-marginless">
                    Move at the Speed of Innovation
                  </p>
                  <p>
                    Teams are under pressure to iterate faster and release
                    features more often. Using feature flags in continuous
                    delivery means you can integrate release, deployment,
                    and operational management into the development cycle.
                  </p>
                  <p>
                    LaunchDarkly's feature management platform gives you
                    granular control over what your users experience so you
                    can safely test in production and quickly get valuable
                    feedback from your users.{' '}
                  </p>
                </div>
              )}

              {tab === 'tabB' && (
                <div className="tabContent tabContent--selected">
                  <p className="text-bold is-marginless">
                    Empowered Product Development
                  </p>
                  <p>
                    LaunchDarkly enables technical and non-technical teams
                    to collaborate more effectively on software releases by
                    giving everyone the visibility that they need.
                  </p>
                  <p>
                    Dev and ops can develop and verify that a feature works
                    in production. QA can test and verify. And product teams
                    can safely release features to users in a controlled
                    fashion. This allows non-technical teams to actively
                    participate in the development cycle, while also taking
                    the burden off of engineering teams.
                  </p>
                </div>
              )}

              {tab === 'tabC' && (
                <div className="tabContent tabContent--selected">
                  <p className="text-bold is-marginless">
                    Build Better Products
                  </p>
                  <p>
                    When you use feature management as a best practice, you
                    can safely separate code deployments from feature
                    releases. This means your developers can develop at the
                    speed of ideation, operations teams can continuously
                    deliver code safely, and business/application owners can
                    independently experiment and provide valuable feedback.
                  </p>
                  <p>
                    By empowering teams to work together more effectively,
                    safely delivery features more frequently, and get
                    feedback from users faster—your organization can be more
                    confident it is maintaining its competitive edge.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    )
  }

  toggleTab = e => {
    e.preventDefault()
    if (this.state.tab !== e.currentTarget.id) {
      this.setState({
        tab: e.currentTarget.id,
      })
    }
  }
}

export default TabsAboutUs
